export enum GenericDiagnosisCodes {
    RoutineDiagnosisCode = "MiproRT",
    RoutineDiagnosisName = "Routine Treatment",
    GenericPrescriptionDiagnosisCode = "MiproScript",
    GenericPrescriptionDiagnosisName = "Prescription",
    HTMLImportedDiagnosisCode = "Imported",
    GymRecoveryDiagnosisCode = "MiProSDGR",
    GymRecoveryDiagnosisName = "Self-Directed Gym/Recovery",
    NoteDraftCode = "MiproNoteDraft",
    NoteDraftCodeName = "NoteDraft"

}
